export default "__VITE_ASSET__Dtasw1dx__"